// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyAQnT79Gykp7oXQUhIJYfQsozu_c9_5Xak",
    authDomain: "mexico-profundo.firebaseapp.com",
    projectId: "mexico-profundo",
    storageBucket: "mexico-profundo.firebasestorage.app",
    messagingSenderId: "775791664327",
    appId: "1:775791664327:web:4da48f24fe4eb6a769f2e2",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
